export default {

    businessDashboard : [
        { path: "automations" , component:() => import("@/modules/automations/components/DashAutomations.vue") , props : true },
        { path: "automations/:uuid" , component:() => import("@/modules/automations/components/AutomationPage.vue") , props : true },
    ]
}


